import { render, staticRenderFns } from "./MproductCreate.vue?vue&type=template&id=13ef169a&scoped=true"
import script from "./MproductCreate.vue?vue&type=script&lang=js"
export * from "./MproductCreate.vue?vue&type=script&lang=js"
import style0 from "./MproductCreate.vue?vue&type=style&index=0&id=13ef169a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ef169a",
  null
  
)

export default component.exports